import type { Kitchen } from '@rta/rta-blueprint-library';

export type GetTrimLabelParams = {
	kitchen: Kitchen;
};

const TRIM_LABELS: Record<string, string> = {
	standard: 'Standard',
	flat: 'Flat',
	mixed: 'Standard | Flat'
};

/** Formats the kitchen-wide corner trim profile for the Kitchen Specifications block. */
export const getTrimLabel = (params: GetTrimLabelParams): string => {
	const { kitchen } = params;

	return TRIM_LABELS[kitchen.trimProfile] ?? 'Standard';
};
